import { render, staticRenderFns } from "./CustomMapLocation.vue?vue&type=template&id=edb3b546&scoped=true"
import script from "./CustomMapLocation.vue?vue&type=script&lang=js"
export * from "./CustomMapLocation.vue?vue&type=script&lang=js"
import style0 from "./CustomMapLocation.vue?vue&type=style&index=0&id=edb3b546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3b546",
  null
  
)

export default component.exports